import React from 'react';
import { render } from 'react-dom';
import { Input, Checkbox, Button } from 'antd';
import Background from '../../images/Background.png'
import Logo from '../../images/LogoCircle.png'
import { translate } from 'react-i18next';
import { compose } from 'redux';
import axios from 'axios';
import { firebaseConnect } from 'react-redux-firebase';
import { fbFunctionsURL } from '../../config.js'


class Register extends React.Component {

  constructor() {
    super();
    this.state = {
      password: null,
      email: 'Loading email address...',
      error: '',
      id: '',
      role: null
    }
  }

  componentDidMount() {
    let message;
    let id = this.props.location.search
    id = id.substr(4)
    let _this = this
    this.setState({ id })
    const url = `${fbFunctionsURL}/getInvite`
    axios.post(url, {
      id: id
    })
      .then(function (response) {
        _this.setState({ role: response.data.role, email: response.data.email })
      })
      .catch(function (error) {
        _this.setState({ error: 'Could not load email address. This might be because you have already registered with this ID.', email: '' })
      })
  }

  acceptInvite = (uid) => {
    const url = `${fbFunctionsURL}/acceptInvitation`
    axios.post(url, {
      id: this.state.id,
      uid: uid
    })
  }

  register = () => {
    let _this = this
    let uid;
    _this.props.firebase.auth().createUserWithEmailAndPassword(_this.state.email, _this.state.password)
      .then(function (firebaseUser) {
        _this.acceptInvite(firebaseUser.uid)
        this.auth().logout
      })
      .catch(function (error) {
        _this.setState({ error: error.message })
      })


  }

  render() {
    const { t } = this.props;
    return (
      <div style={styles.background}>
        <div style={styles.container}>
          <img src={Logo} alt="Skilltracker logo" style={styles.logo} />
          <div style={styles.inner}>
            <p style={styles.email}>{this.state.email}</p>
            <p style={styles.message}>
              {this.state.role &&
                this.state.role == 'student' ? 'Please type in the password you would like to use to log into the app.'
                : 'Please type in the password you would like to use to log into the web portal.'
              }
            </p>
            <input style={styles.input} placeholder="Password" type="password" onChange={(e) => this.setState({ password: e.target.value })} />
            <p style={styles.invalid}>{this.state.error}</p>
            <Button disabled={this.state.password && this.state.email ? false : true} style={styles.button} onClick={() => this.register()} type="primary">Register</Button>
          </div>
        </div>
      </div>
    )
  }
}
const enhancer = compose(
  translate('lang'),
  firebaseConnect(),
)
export default enhancer(Register);

const styles = {

  background: {
    backgroundImage: `url(${Background})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    height: '100vh',
    width: '100vw',
    position: 'absolute'
  },
  email: {
    fontSize: '20px',
    color: 'white'
  },

  message: {
    fontSize: '16px',
    textAlign: 'justify',
    color: '#757a7c',
    marginTop: '20px'
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: '380px',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    padding: '20px'
  },

  logo: {
    width: '183px',
    marginBottom: '60px'
  },

  label: {
    color: '#696969',
    fontSize: '14px',
    marginRight: 'auto',
    marginBottom: '5px',
    fontWeight: 600
  },

  input: {
    width: '100%',
    marginBottom: '20px',
    height: '32px',
    border: '0.8px solid #D9D9D9',
    borderRadius: '5px',
    paddingLeft: '10px',
    backgroundColor: 'white'
  },

  button: {
    marginTop: '40px',
    marginBottom: '20px',
    width: '105px'
  },

  inner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
  },

  msg: {
    fontSize: '14px',
    marginRight: 'auto',
    color: '#319D02',
    marginTop: '-10px'
  },
  invalid: {
    fontSize: '14px',
    marginRight: 'auto',
    color: 'red',
    marginTop: '-10px'
  }

}



// WEBPACK FOOTER //
// ./src/containers/Register/index.jsx